import PercentCompleteLine from './PercentCompleteLine'

export default PercentCompleteLine
